import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {ScriptCoreEnd} from './coreend.script.js';

import ambiant from '../ambiant.mp3';

// import ambiant from './Aperture-Tag-OST-28-Central-Hub-_152kbit_Opus_.mp3';
// import ambiant2 from './Fountain Water Bubbling.mp3';

function gameobjectcoreend() {

    const coreend = new HYPERCUBEJS.Node('coreend');
    const meshcoreend = new HYPERCUBEJS.MeshBox('meshcoreend', [2, 2, 2]);
    const materialmeshcoreend = new HYPERCUBEJS.MaterialColor('materialmeshcoreend', {'color': [0, 0, 0]});

    meshcoreend.setmaterial(materialmeshcoreend);
    coreend.addmesh(meshcoreend);
    coreend.setaudio(new Audio(ambiant));
    coreend.setscript(new ScriptCoreEnd());

    coreend.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-1, -1, -1],
        'max': [1, 1, 1]
    });

    return coreend;
}

export {

    gameobjectcoreend
};

export default gameobjectcoreend;
